import { FilterRadioGroup } from "components/FilterRadioGroup";
import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import { device, mq } from "lib/media-query";
import React from "react";
import { useCount } from "services/search";
import styled from "styled-components";
import { datalayerWrapper } from "lib/analytics/datalayerHelpers";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    align-items: end;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

const sendClickToDataLayer = (filterAction, filterValue) => {
    const eventObject = {
        event: "filterOption",
        filter_action: filterAction,
        filter_name: "btw",
        filter_value: filterValue
    };

    datalayerWrapper(eventObject);
};

export const BTWFilter = ({ condensed }) => {
    const btwVerrekenbaarCount = useCount("btwVerrekenbaar");
    const [btwVerrekenbaarValue, , onBtwVerrekenbaarChange] = useField("btwVerrekenbaar");
    const [btwPriceValue, , onbtwPriceChange] = useField("btwprijs");

    const onChangeBtwPrice = (_, value) => {
        const selected = value[0];
        const action = selected ? "on" : "off";
        const filterValue = !selected
            ? "geen voorkeur"
            : selected === "true"
            ? "toon alleen aanbod incl. btw"
            : "toon alleen aanbod excl. btw";

        sendClickToDataLayer(action, filterValue);
        onbtwPriceChange(value);
    };

    const priceOptions = {
        "Geen voorkeur": "none",
        "Toon alleen aanbod incl. BTW": "true",
        "Toon alleen aanbod excl. BTW": "false"
    };

    const filterPriceOptions =
        Object.entries(priceOptions).map(([key, value]) => ({
            id: value,
            displayName: `${key}`,
            naam: `${key}`
        })) || [];

    const btwVerrekenbaarOptions = [
        {
            id: "true",
            displayName: "BTW verrekenbaar",
            aantal: btwVerrekenbaarCount?.true
        }
    ];

    return (
        <Grid condensed={condensed}>
            <FilterRadioGroup
                filterId="btwprijs"
                options={filterPriceOptions}
                id=""
                selected={btwPriceValue[0] || "none"}
                handleChange={onChangeBtwPrice}
                columns={3}
                isSingle
                dontSendClickToDataLayer
            />

            <FilterCheckList
                filterId="filter-btw-verrekenbaar"
                options={btwVerrekenbaarOptions}
                value={btwVerrekenbaarValue}
                handleChange={(_, value) => onBtwVerrekenbaarChange(value)}
                columns={condensed ? 1 : 2}
                datalayerKey="btw"
                maxSize={0}
            />
        </Grid>
    );
};
